<template>
    <div class="mt-2">
        <div>
            <v-toolbar
                class="elevation-1 white--text"
                color="primary"
                height="50px"
            >
                <v-toolbar-title>
                    <v-icon class="white--text">
                        fa-car
                    </v-icon>
                    Vehicles
                </v-toolbar-title>
                <v-divider
                    class="mx-2"
                    inset
                    vertical
                />
                <v-spacer />
                <EditPersonVehicleDialog />
                <AddPersonVehicleDialog :person-id="personId" />
            </v-toolbar>
            <v-data-table
                :headers="holidayHeaders"
                :items="personVehicleList"
                :sort-by.sync="sortBy"
                :sort-desc="true"
                class="elevation-1"
                v-if="person !== undefined"
            >
                <template
                    slot="item"
                    slot-scope="props"
                >
                    <tr>
                        <td class="text-xs-left">{{ props.item.registrationNumber }}</td>
                        <td class="text-xs-left">{{ props.item.engineSize }}</td>
                        <td class="text-xs-left">{{ props.item.fuelType }}</td>
                        <td class="text-xs-left">{{ props.item.mileageRate }}</td>
                        <td class="text-xs-left">{{ props.item.vatMileage }}</td>
                        <td class="text-xs-left">{{ props.item.ownershipType }}</td>
                        <td class="text-xs-left">{{ props.item.startDate | formatDate }}</td>
                        <td class="text-xs-left">{{ props.item.isCurrent === true ? 'Yes' : 'No ' }}</td>
                        <td class="text-xs-left">{{ props.item.comments }}</td>
                        <td class="justify-center layout px-0">
                            <v-icon
                                @click="editItem(props.item)"
                                class="mr-2"
                                small
                                style="display: inline-flex;"
                            >
                                edit
                            </v-icon>
                            <v-icon
                                @click="deleteItem(props.item)"
                                small
                                style="display: inline-flex;"
                            >
                                delete
                            </v-icon>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex";
    import {DELETE_PERSON_VEHICLE, FETCH_PERSON_VEHICLE_LIST, UPDATE_PERSON_VEHICLE} from "@/store/person_vehicle/actions";
    import {LOAD_PERSON_VEHICLE_TO_EDIT, RESET_DEFAULT_VEHICLE_TO_EDIT, TOGGLE_EDIT_PERSON_VEHICLE_DIALOG, UPDATE_NEW_PERSON_VEHICLE} from "@/store/person_vehicle/mutations";
    import EditTableFunctions from '../editTableFunctions';
    import AddPersonVehicleDialog from "./AddPersonVehicleDialog";
    import EditPersonVehicleDialog from "./EditPersonVehicleDialog";

    export default {
        name: "PersonVehiclesTable",

        components: {AddPersonVehicleDialog, EditPersonVehicleDialog},

        mixins: [
            EditTableFunctions,
        ],

        props: {
            personId: {
                type: Number,
                required: true,
            },
        },

        data() {
            return {
                idName: 'vehicleId',
                dialog: false,
                holidayHeaders: [
                    {
                        text: 'Registration',
                        align: 'left',
                        value: 'registrationNumber'
                    },
                    {text: 'Engine Size', value: 'engineSize'},
                    {text: 'Fuel Type', value: 'fuelType'},
                    {text: 'Mileage Rate', value: 'mileageRate'},
                    {text: 'Mileage VAT', value: 'vatMileage'},
                    {text: 'Ownership Type', value: 'ownershipType'},
                    {text: 'Start Date', value: 'startDate'},
                    {text: 'Is Current', value: 'isCurrent'},
                    {text: 'Comments', value: 'comments'},
                    {text: 'Actions', value: 'name', sortable: false}
                ],
                sortBy: 'startDate',
                rowsPerPageItems: [10, 20, 50, {"text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1}],
                pagination: {
                    rowsPerPage: 10
                },
                editedId: -1,
            }
        },

        computed: {
            ...mapGetters(
            [
                "person",
                "personVehicleList",
                "employmentTypeList",
            ]
            )
        },

        mounted() {
            if (this.personId) {
                // this.fetchAllTableItems();
            }
        },

        methods: {
            ...mapActions({
                fetchTableList: FETCH_PERSON_VEHICLE_LIST,
                updateTableItemRecord: UPDATE_PERSON_VEHICLE,
                deleteTableItem: DELETE_PERSON_VEHICLE,
            }),
            ...mapMutations({
                toggleEditDialog: TOGGLE_EDIT_PERSON_VEHICLE_DIALOG,
                loadTableItemToEdit: LOAD_PERSON_VEHICLE_TO_EDIT,
                updateTableItemToEdit: UPDATE_NEW_PERSON_VEHICLE,
                resetEditItemToDefault: RESET_DEFAULT_VEHICLE_TO_EDIT,
            })
        },
    }
</script>

<style scoped>
</style>
